import React, {Component} from 'react';
import {inject, observer} from 'mobx-react';
import {FormattedMessage, injectIntl} from 'react-intl';
import Close from 'react-icons/lib/io/close';
import Slide from '@material-ui/core/Slide';
import DialogWrapper from '../../components/dialog/Dialog';
import {isMobile} from '../../utils/screenUtility';
import './styles.scss';
import MeetingButton from "./MeetingButton";
import {Roles} from "../../constants/enums";


@injectIntl
@inject('manageStore', 'dialogStore', 'videoChatStore')
@observer
class StudentMeetingDialog extends Component {
    handleClick = (teacher) => () => {
        const {videoChatStore, dialogStore} = this.props;
        this.props.onClose();
        if (teacher.videoMeetingActive && teacher.videoMeetingUrl) {
            window.open(teacher.videoMeetingUrl, '_blank');
        } else {
            videoChatStore.startVideoChat(teacher);
        }
    }
    render() {
        const {onClose, open, intl: {formatMessage: translate}, manageStore} = this.props;
        const dialogProps = {
            ...(isMobile() && {TransitionComponent: Slide}),
            TransitionProps: {direction: 'up'},
            classes: {root: 'student-meeting-modal-root', paper: 'paper'},
            open: open,
            onExited: onClose,
            onClose: onClose
        };

        return (
            <DialogWrapper {...dialogProps}>
                <div className="student-meeting-modal">
                    <button className="student-meeting-modal-close" onClick={onClose}>
                        <Close/>
                    </button>
                    <h3><FormattedMessage id={'zoom.dialog.header'}/></h3>
                    <div className="student-meeting-modal-buttons">
                        {manageStore.teachersWithStatus.map(teacher => {
                            if (teacher.role !== Roles.Teacher) {
                                return null;
                            }
                            return <MeetingButton key={teacher.id} teacher={teacher} onClick={this.handleClick(teacher)}/>
                        })}
                    </div>
                </div>
            </DialogWrapper>
        );
    }
}

export default StudentMeetingDialog;
